import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-model-icon9",
  "use": "icon-model-icon9-usage",
  "viewBox": "0 0 26 14",
  "content": "<symbol viewBox=\"0 0 26 14\" fill=\"\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-model-icon9\">\n<g id=\"icon-model-icon9_Group 1321317279\">\n<rect id=\"icon-model-icon9_Rectangle 34624540\" x=\"0.5\" y=\"0.5\" width=\"25\" height=\"13\" rx=\"6.5\" stroke=\"\" />\n<circle id=\"icon-model-icon9_Ellipse 403\" cx=\"19\" cy=\"7\" r=\"4.5\" fill=\"white\" stroke=\"\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol